import { map, tap, shareReplay } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { environment } from 'environments/environment';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class ServicosService {
  public urls: any = {};
  public modulos: any = {};
  private urls$;
  private modulos$;

  constructor(public router: Router, public http: HttpClient) {}

  buscarUrls() {
    if (!this.urls$) {
      this.urls$ = this.buscarUrlsCached();
    }
    return this.urls$;
  }

  buscarUrlsCached() {
    return this.http
      .get<any>(environment.baseCorporativoUrl + '/servicos/corporativo')
      .pipe(
        shareReplay(1), // Cache
        tap(res => {
          this.urls = res;
        })
      );
  }

  buscarModulos() {
    if (!this.modulos$) {
      this.modulos$ = this.buscarModulosCached();
    }
    return this.modulos$;
  }

  buscarModulosCached() {
    return this.http
      .get<any>(environment.baseCorporativoUrl + '/servicos/modulos')
      .pipe(
        map(modulos => this.reduceVetorParaObjeto(modulos)),
        shareReplay(1), // Cache
        tap(res => {
          this.modulos = res;
        })
      );
  }

  private reduceVetorParaObjeto(modulos: any): any {
    return modulos.reduce(
      // tslint:disable-next-line:no-shadowed-variable
      (map, obj) => ((map[obj.nome] = obj.url), map),
      {}
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/service/core/servicos.service.ts